import React, { useContext, useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { BufferService, LoadingContext } from '../M_Components'
import { useTranslation } from 'react-i18next'

export default function RecentActivity() {
    const ctx = useContext(LoadingContext)
    const [dataRecentActivity, setDataRecentActivity] = useState([])
    const [page, setPage] = useState(1)
    const [loading, setLoading] = useState(false)
    const [hasMore, setHasMore] = useState(true)
    const bufferServiceActivity = useMemo(() => new BufferService('LoginActivity'), [])
    const { t } = useTranslation()
    const sentinelRef = useRef(null)
    const isFetchingRef = useRef(false)

    const fetchData = useCallback(async () => {
        if (loading || !hasMore || isFetchingRef.current) return
        isFetchingRef.current = true
        setLoading(true)

        try {
            const filter = `?$page=${page}&pageSize=30&filterMine=true&orderBy=LoginTime desc`
            const response = await bufferServiceActivity.filter(filter)
            const items = response.Items || []

            if (items.length === 0) {
                setHasMore(false)
            } else {
                setDataRecentActivity(prev => [...prev, ...items])
                setPage(prev => prev + 1)
            }
        } catch (error) {
            console.error("Erro ao buscar atividades:", error)
        } finally {
            setLoading(false)
            isFetchingRef.current = false
        }
    }, [page, hasMore, loading, bufferServiceActivity])


    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (!sentinelRef.current) return

        const observer = new IntersectionObserver(
            entries => {
                if (entries[0]?.isIntersecting) {
                    fetchData()
                }
            },
            { root: null, rootMargin: '200px', threshold: 0 }
        )

        observer.observe(sentinelRef.current)
        return () => observer.disconnect()
    }, [fetchData])


    return (
        <div className="divGlobalSettings" data-testid="settings-container">
            <div className="subTitleSettings">
                <div>
                    <div style={{ color: ctx.secondaryColor }} data-testid="change-password-title">
                        {t('RecentActivity')}
                    </div>
                    <div className="labelSubtitleSettings" data-testid="change-password-info">
                        {t("InfoRecentActivity")}
                    </div>
                </div>
            </div>

            <div className="activityTable">
                <div className="activityHeader">
                    <div>{t('Device')}</div>
                    <div>{t('Date')}</div>
                    <div>{t('Browser')}</div>
                    <div>{t('IP')}</div>
                    <div>{t('Location')}</div>
                    <div>{t('Status')}</div>
                </div>

                {dataRecentActivity.map((activity, index) => (
                    <div className="activityRow" key={index}>
                        <div>
                            {activity.Device === 'Desktop' ? (
                                <img src="/icons/svgsDaNet/device-laptop.svg" alt="Device" className='iconDevice' />
                            ) : (
                                <img src="/icons/svgsDaNet/IP2.svg" alt="Device" className='iconDevice' />
                            )}
                        </div>
                        <div>{new Date(activity.LoginTime).toLocaleString().replace("T", " ").split(".")[0]}</div>
                        <div>{activity.Browser}</div>
                        <div>{activity.IPAddress}</div>
                        <div className='locationCell'>
                            {activity.Location || 'Sem resultados'}
                            <div className="popoverWrapper">
                                <img src="/icons/svgsDaNet/info-small.svg" alt="info" className="iconInfo" />
                                <div className="popoverContent">{t("InfoLocation")}</div>
                            </div>
                        </div>
                        <div className="statusCell">
                            {activity.Successful === true ? (
                                <>
                                    <img src="/icons/svgsDaNet/check-green.svg" alt="Success" className="iconStatusLogin" />
                                    {t("SuccessLogin")}
                                </>
                            ) : (
                                <>
                                    <img src="/icons/svgsDaNet/x-red.svg" alt="Failed" className="iconStatusLogin" />
                                    {t("FailedLogin")}
                                </>
                            )}
                        </div>
                    </div>
                ))}

                <div ref={sentinelRef} style={{ height: 1 }} />
                {loading && <div style={{ textAlign: "center", padding: "10px" }}>{t("Loading")}...</div>}
                {!hasMore && <div style={{ textAlign: "center", padding: "10px" }}>{t("NoMoreResults")}</div>}
            </div>
        </div>
    )
}
